export default __webpack_public_path__ + "static/media/kohler-logo-white.8699b303.png";